<template>
  <button
    id="secondaryNavToggleButton"
    v-tooltip.right="{
      value: isVisible ? 'Collapse - shortcut: [' : 'Expand - shortcut: [',
      hideDelay: 100,
      showDelay: 500,
    }"
    :class=" [{ 'cursor-e-resize rtl:cursor-w-resize':
                !isVisible },
              { 'cursor-w-resize rtl:cursor-e-resize': isVisible }]"
    :aria-label="isVisible ? 'Collapse secondary navigation' : 'Expand secondary navigation'"
    :aria-expanded="isVisible"
    data-test-id="secondary-nav-toggle-button"
    class="flex flex-col items-center justify-center bg-surface-light size-6 hover:bg-brand-light outline-brand outline-offset-1 rounded-full"
    @click="handleToggle"
  >
    <AM3Icon :type="isVisible ? 'navigation-open' : 'navigation-close'" />
  </button>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const isVisible = computed(() =>
  store.getters['secondaryNavigationModule/isSecondaryNavigationVisible'] ?? true,
)

function handleToggle() {
  const newValue = !isVisible.value
  store.commit('secondaryNavigationModule/SET_IS_SECONDARY_NAVIGATION_VISIBLE', newValue)

  // PrimeVue tooltips only hide on mouse/click/Escape events fired on their
  // anchor. Toggling via the keyboard shortcut fires none of those, so the
  // anchors' tooltips stick. Dispatch mouseleave to dismiss them manually.
  // The logo anchor owns the "Open sidebar, shortcut [" tooltip.
  ;['secondaryNavToggleButton', 'sidebarLogoTooltipAnchor'].forEach((id) => {
    document.getElementById(id)?.dispatchEvent(new MouseEvent('mouseleave'))
  })

  try {
    localStorage.setItem('secondaryNavVisible', JSON.stringify(newValue))
  }
  catch (e) {
    console.warn('Failed to save secondary nav state to localStorage:', e)
  }
}

// Keyboard navigation
function handleKeydown(event: KeyboardEvent) {
  if (event.key === '[') {
    handleToggle()
  }
}

onMounted(() => {
  window.addEventListener('keydown', handleKeydown)
})

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown)
})
</script>
